import { render, staticRenderFns } from "./EditConfirmDialog.vue?vue&type=template&id=4be97e5f&scoped=true&"
import script from "./EditConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./EditConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditConfirmDialog.vue?vue&type=style&index=0&id=4be97e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be97e5f",
  null
  
)

export default component.exports